const ciselnikyPrefixPath = '/external/ciselniky';
const spravaAktovEuPrefixPath = '/external/sprava-aktov-eu';
const pravoEuPrefixPath = '/internal/pravo-eu';

export {
  ciselnikyPrefixPath, spravaAktovEuPrefixPath, pravoEuPrefixPath,
};
